import type { NumberInputProps } from '../../NumberInput/index.js'
import { NumberInput } from '../../NumberInput/index.js'
import { FormControlLayout } from '../FormControlLayout.js'
import { FormControlProps } from '../types.js'
import { extractLayoutProps } from '../utils.js'

export type FormControlNumberInputProps = FormControlProps &
  NumberInputProps & { className?: string }

export const FormControlNumberInput = ({
  value,
  ...rest
}: FormControlNumberInputProps) => {
  const { layoutProps, inputProps } = extractLayoutProps(rest)

  return (
    <FormControlLayout {...layoutProps}>
      <NumberInput value={value} {...inputProps} />
    </FormControlLayout>
  )
}
